import React, { useEffect, useState } from "react";
import CourseHeader from "../header/index";
import { Col, Row } from "react-bootstrap";
import {
    Link,
    // useLocation,
    useParams
} from "react-router-dom";
import '../Journal/journal.css'
import Footer from "../footer";
// import InnerBanner from "../../assets/img/inner-banner.jpg";
import StudentSideBar from "../student/sidebar";

// import {
//     useDispatch
//     // , useSelector
// } from "react-redux";
// import { SpissuesgetById } from "../../Redux/SpecialIssues/specialissueSlice";
import Bannerpage from "../Banner";
// import queryString from 'query-string';
import moment from "moment";
import PdfDownloader from "../DownloadPDF";
import axios from "axios";
import ContentRenderer from "../ContentRender";

// Mobile-responsive styles that only apply to mobile devices
const mobileStyles = `
    /* Mobile-only styles - these won't affect desktop */
    @media (max-width: 768px) {
        /* Container and layout improvements */
        .container-fluid {
            padding: 15px 10px !important;
        }
        
        .row {
            margin: 0 !important;
        }
        
        .col-lg-8, .col-md-8, .col-xs-12 {
            padding: 0 10px !important;
        }
        
        /* Header improvements */
        .cardb {
            padding: 12px !important;
            margin-bottom: 12px !important;
            border-radius: 8px !important;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
        }
        
        /* Title improvements */
        div > strong[style*="fontSize: 25"] {
            font-size: 1.3rem !important;
            line-height: 1.4 !important;
            margin-bottom: 8px !important;
            display: block !important;
            word-wrap: break-word !important;
        }
        
        /* Authors section improvements */
        div > label {
            font-size: 0.9rem !important;
            line-height: 1.5 !important;
            margin-bottom: 8px !important;
            display: block !important;
        }
        
        /* Corresponding authors improvements */
        div[style*="display: flex"] {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 4px !important;
            margin-bottom: 12px !important;
        }
        
        div[style*="display: flex"] strong {
            margin-right: 0 !important;
            margin-bottom: 5px !important;
            font-size: 0.9rem !important;
        }
        
        /* Authors info link improvements */
        div[style*="fontWeight: bold"][style*="cursor: pointer"] {
            color: #007bff !important;
            text-decoration: underline !important;
            margin-bottom: 12px !important;
            display: inline-block !important;
            font-size: 0.9rem !important;
        }
        
        /* Content section improvements */
        div > h3 {
            font-size: 1.2rem !important;
            margin-bottom: 8px !important;
            line-height: 1.4 !important;
            color: #333 !important;
        }
        
        div > div[style*="lineHeight: 1.9"] {
            font-size: 0.95rem !important;
            line-height: 1.7 !important;
            text-align: justify !important;
            word-wrap: break-word !important;
        }
        
        /* Enforce link styles for ContentRenderer on mobile */
        .content-renderer a {
            color: #0066cc !important;
            text-decoration: underline !important;
            text-decoration-color: #0066cc !important;
            text-decoration-thickness: 1px !important;
            text-decoration-style: solid !important;
            font-weight: inherit !important;
            font-style: inherit !important;
            background-color: transparent !important;
            border: none !important;
            outline: none !important;
        }

        /* Support CKEditor-specific classes and data attributes */
        .content-renderer a.ck-link-blue,
        .content-renderer a.ck-external-link,
        .content-renderer a.ck-forced-blue,
        .content-renderer a[data-link-color="blue"],
        .content-renderer a[data-force-blue="true"],
        .content-renderer a[data-external-link="true"],
        .content-renderer a[data-ck-link-id] {
            color: #0066cc !important;
            text-decoration: underline !important;
        }

        /* Hover state for mobile (if supported) */
        .content-renderer a:hover {
            color: #0052a3 !important;
            text-decoration: underline !important;
        }

        /* Visited state */
        .content-renderer a:visited {
            color: #0066cc !important;
            text-decoration: underline !important;
        }

        /* Ensure nested links are styled */
        .content-renderer *[class*="ck-link-blue"] a,
        .content-renderer *[data-link-color="blue"] a,
        .content-renderer *[data-force-blue="true"] a,
        .content-renderer *[data-external-link="true"] a,
        .content-renderer *[data-ck-link-id] a {
            color: #0066cc !important;
            text-decoration: underline !important;
        }
        
        /* Author info card improvements */
        .card {
            padding: 12px !important;
            margin-top: 16px !important;
            border-radius: 8px !important;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
        }
        
        .card > strong {
            font-size: 1.2rem !important;
            margin-bottom: 12px !important;
            display: block !important;
        }
        
        /* Button improvements */
        .btn {
            margin: 5px !important;
            font-size: 0.85rem !important;
            padding: 8px 12px !important;
            border-radius: 4px !important;
        }
        
        /* PDF buttons container */
        div[style*="textAlign: right"] {
            display: flex !important;
            justify-content: center !important;
            gap: 8px !important;
            margin-top: 15px !important;
            flex-wrap: wrap !important;
        }
        
        div[style*="textAlign: right"] .btn {
            flex: 1 !important;
            max-width: 150px !important;
        }
        
        /* Improve content readability on mobile */
        .content-renderer {
            text-align: justify !important;
            word-wrap: break-word !important;
            overflow-wrap: break-word !important;
            line-height: 1.6 !important;
        }
        
        /* Ensure links are blue on mobile */
        .content-renderer a,
        .content-renderer a[href] {
            color: #0066cc !important;
            text-decoration: underline !important;
            text-decoration-color: #0066cc !important;
        }
        
        /* Ensure images are responsive on mobile */
        .content-renderer img {
            max-width: 100% !important;
            height: auto !important;
            border-radius: 4px !important;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
        }
        
        /* Preserve image alignment on mobile - all CKEditor formats */
        .content-renderer img[data-align="left"],
        .content-renderer img[style*="float: left"],
        .content-renderer img.align-left,
        .content-renderer img.image-style-align-left,
        .content-renderer img.image-align-left,
        .content-renderer img.ck-align-left,
        .content-renderer figure.image-style-align-left,
        .content-renderer figure.image-align-left,
        .content-renderer figure.align-left,
        .content-renderer figure.ck-align-left,
        .content-renderer figure[style*="float: left"] {
            float: left !important;
            margin: 5px 10px 5px 0 !important;
            display: inline !important;
            clear: none !important;
        }
        
        .content-renderer img[data-align="right"],
        .content-renderer img[style*="float: right"],
        .content-renderer img.align-right,
        .content-renderer img.image-style-align-right,
        .content-renderer img.image-align-right,
        .content-renderer img.ck-align-right,
        .content-renderer figure.image-style-align-right,
        .content-renderer figure.image-align-right,
        .content-renderer figure.align-right,
        .content-renderer figure.ck-align-right,
        .content-renderer figure[style*="float: right"] {
            float: right !important;
            margin: 5px 0 5px 10px !important;
            display: inline !important;
            clear: none !important;
        }
        
        .content-renderer img[data-align="center"],
        .content-renderer img.align-center,
        .content-renderer img.image-style-align-center,
        .content-renderer img.image-align-center,
        .content-renderer img.ck-align-center,
        .content-renderer figure.image-style-align-center,
        .content-renderer figure.image-align-center,
        .content-renderer figure.align-center,
        .content-renderer figure.ck-align-center,
        .content-renderer img:not([data-align]):not([style*="float"]):not([class*="align"]) {
            display: block !important;
            margin: 10px auto !important;
            float: none !important;
            clear: both !important;
        }
        
        /* Better table handling on mobile */
        .content-renderer table {
            width: 100% !important;
            max-width: 100% !important;
            overflow-x: auto !important;
            display: block !important;
            font-size: 0.85rem !important;
            border-collapse: collapse !important;
            margin: 15px 0 !important;
        }
        
        .content-renderer table th,
        .content-renderer table td {
            padding: 6px !important;
            word-wrap: break-word !important;
            border: 1px solid #ddd !important;
        }
        
        /* Improve list readability on mobile */
        .content-renderer ul,
        .content-renderer ol {
            padding-left: 15px !important;
            margin: 10px 0 !important;
        }
        
        .content-renderer li {
            margin-bottom: 6px !important;
            line-height: 1.5 !important;
        }
        
        /* Better spacing for mobile */
        div > div {
            margin-bottom: 12px !important;
        }
        
        /* Citation and date info improvements */
        div[style*="marginTop: 20"] {
            margin-top: 10px !important;
            padding-top: 6px !important;
            font-size: 0.85rem !important;
            line-height: 1.6 !important;
        }
        
        /* Affiliation improvements */
        .card label {
            margin-bottom: 5px !important;
            font-size: 0.85rem !important;
            line-height: 1.5 !important;
            display: block !important;
        }
        
        /* Improve overall spacing */
        br {
            margin: 10px 0 !important;
        }
    }
    
    @media (max-width: 576px) {
        /* Even smaller screens */
        .container-fluid {
            padding: 10px 5px !important;
        }
        
        .col-lg-8, .col-md-8, .col-xs-12 {
            padding: 0 5px !important;
        }
        
        /* Smaller title */
        div > strong[style*="fontSize: 25"] {
            font-size: 1.1rem !important;
        }
        
        /* Smaller authors text */
        div > label {
            font-size: 0.85rem !important;
        }
        
        /* Smaller headings */
        div > h3 {
            font-size: 1.1rem !important;
        }
        
        /* Smaller content */
        div > div[style*="lineHeight: 1.9"] {
            font-size: 0.9rem !important;
        }
        
        /* Smaller card padding */
        .card {
            padding: 10px !important;
        }
        
        .card > strong {
            font-size: 1.1rem !important;
        }
        
        /* Stack buttons vertically on very small screens */
        div[style*="textAlign: right"] {
            flex-direction: column !important;
            gap: 4px !important;
        }
        
        div[style*="textAlign: right"] .btn {
            max-width: none !important;
            width: 100% !important;
            margin: 2px 0 !important;
        }
        
        /* Smaller content */
        .content-renderer {
            font-size: 0.9rem !important;
        }
        
        /* Smaller table text */
        .content-renderer table {
            font-size: 0.8rem !important;
        }
        
        .content-renderer table th,
        .content-renderer table td {
            padding: 4px !important;
        }
        
        /* Smaller citation and date info */
        div[style*="marginTop: 20"] {
            font-size: 0.8rem !important;
        }
        
        /* Smaller affiliation text */
        .card label {
            font-size: 0.8rem !important;
        }
        
        /* Reinforce link styles for very small screens */
        .content-renderer a {
            color: #0066cc !important;
            text-decoration: underline !important;
        }

        /* Support CKEditor-specific classes and data attributes */
        .content-renderer a.ck-link-blue,
        .content-renderer a.ck-external-link,
        .content-renderer a.ck-forced-blue,
        .content-renderer a[data-link-color="blue"],
        .content-renderer a[data-force-blue="true"],
        .content-renderer a[data-external-link="true"],
        .content-renderer a[data-ck-link-id] {
            color: #0066cc !important;
            text-decoration: underline !important;
        }
    }
    
    /* Ensure images are properly justified and responsive across all devices */
    .content-renderer img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    /* Preserve image alignment across all devices - all CKEditor formats */
    .content-renderer img[data-align="left"],
    .content-renderer img[style*="float: left"],
    .content-renderer img.align-left,
    .content-renderer img.image-style-align-left,
    .content-renderer img.image-align-left,
    .content-renderer img.ck-align-left,
    .content-renderer figure.image-style-align-left,
    .content-renderer figure.image-align-left,
    .content-renderer figure.align-left,
    .content-renderer figure.ck-align-left,
    .content-renderer figure[style*="float: left"] {
        float: left !important;
        margin: 10px 15px 10px 0 !important;
        display: inline !important;
        clear: none !important;
    }
    
    .content-renderer img[data-align="right"],
    .content-renderer img[style*="float: right"],
    .content-renderer img.align-right,
    .content-renderer img.image-style-align-right,
    .content-renderer img.image-align-right,
    .content-renderer img.ck-align-right,
    .content-renderer figure.image-style-align-right,
    .content-renderer figure.image-align-right,
    .content-renderer figure.align-right,
    .content-renderer figure.ck-align-right,
    .content-renderer figure[style*="float: right"] {
        float: right !important;
        margin: 10px 0 10px 15px !important;
        display: inline !important;
        clear: none !important;
    }
    
    .content-renderer img[data-align="center"],
    .content-renderer img.align-center,
    .content-renderer img.image-style-align-center,
    .content-renderer img.image-align-center,
    .content-renderer img.ck-align-center,
    .content-renderer figure.image-style-align-center,
    .content-renderer figure.image-align-center,
    .content-renderer figure.align-center,
    .content-renderer figure.ck-align-center,
    .content-renderer img:not([data-align]):not([style*="float"]):not([class*="align"]) {
        display: block !important;
        margin: 10px auto !important;
        float: none !important;
        clear: both !important;
    }
    
    /* Improve content readability */
    .content-renderer {
        text-align: justify;
        word-wrap: break-word;
        overflow-wrap: break-word;
        line-height: 1.5;
    }
    
    /* Better spacing for content sections */
    div > div {
        margin-bottom: 12px;
    }
    
    /* Improve author info display */
    .card {
        margin-top: 12px;
        padding: 14px;
    }
    
    /* Better citation and date info display */
    div[style*="marginTop: 20"] {
        margin-top: 10px;
        padding-top: 6px;
        border-top: 1px solid #eee;
    }
    
    /* Improve affiliation display */
    .card label {
        margin-bottom: 5px;
        line-height: 1.4;
    }
    
    /* Improve links */
    a {
        color: #007bff;
        text-decoration: none;
        word-break: break-word;
    }
    
    a:hover {
        text-decoration: underline;
    }
    
    /* Improve overall mobile experience */
    @media (max-width: 768px) {
        /* Better touch targets */
        .btn {
            min-height: 44px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
        }
        
        /* Better spacing between sections */
        div > div {
            margin-bottom: 12px !important;
        }
        
        /* Improve readability */
        * {
            -webkit-text-size-adjust: 100% !important;
            -ms-text-size-adjust: 100% !important;
        }
    }
`;

const ArchiveHtml = () => {
    const handleScrollToTop = () => {
        window.scrollTo(0, 0);
    }

    // const { spIssue } = useSelector((state) => state.spIssueData)
    // const location = useLocation();
    // const query = queryString.parse(location.search);

    // Parse the article data back to an object
    // const article = query.article ? JSON.parse(query.article) : null;

    const [article, setArticle] = useState({})
    console.log(article, "artld")

    // const dispatch = useDispatch();
    const { ArchiveHtml, slug } = useParams();
    const [missingAffiliations, setMissingAffiliations] = useState([]);
    console.log(ArchiveHtml, 'vghdvdchgsdvc');

    // Function to enforce link styles dynamically
    const enforceLinkStyles = () => {
        const links = document.querySelectorAll('.content-renderer a');
        links.forEach((link) => {
            link.style.cssText = `
        color: #0066cc !important;
        text-decoration: underline !important;
        text-decoration-color: #0066cc !important;
        text-decoration-thickness: 1px !important;
        text-decoration-style: solid !important;
        font-weight: inherit !important;
        font-style: inherit !important;
        background-color: transparent !important;
        border: none !important;
        outline: none !important;
      `;
            // Add CKEditor-compatible classes and attributes
            link.classList.add('ck-link-blue', 'ck-external-link', 'ck-forced-blue');
            link.setAttribute('data-link-color', 'blue');
            link.setAttribute('data-force-blue', 'true');
            link.setAttribute('data-external-link', 'true');
            link.setAttribute('data-ck-link-id', `link-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`);
        });
    };


    const getArchiveDetailesBySlug = () => {
        axios.get(`${process.env.REACT_APP_URL}/articleDetails/${ArchiveHtml}`)
            .then((res) => {
                console.log(res?.data)
                setArticle(res?.data?.data?.[0])
            })
            .catch((err) => {
                console.log(err)
            })
    }

    console.log(article, "Parsed article");


    const scrollToAuthorInfo = () => {
        const element = document.getElementById('info');
        if (element) {
            const yOffset = -80; // adjust this offset based on your header height
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }

    const getStyledHeading = (heading) => {
        if (!heading || typeof heading !== 'string') return { text: heading, style: {} };
        const normalized = heading.trim().toLowerCase();
        // Handle common variations and punctuation
        const cleanHeading = normalized.replace(/[:\s\-_]+$/, '').replace(/^[:\s\-_]+/, '');
        const isTarget = cleanHeading === 'abstract' || cleanHeading === 'keywords' || cleanHeading === 'introduction';
        return {
            text: isTarget ? cleanHeading.toUpperCase() : heading,
            style: isTarget ? { color: 'rgb(57,181,74)' } : {}
        };
    }


    useEffect(() => {
        // dispatch(SpissuesgetById(slug));
        getArchiveDetailesBySlug()
    }, [])

    // Add mobile styles to document head
    // useEffect(() => {
    //     const styleElement = document.createElement('style');
    //     styleElement.textContent = mobileStyles;
    //     document.head.appendChild(styleElement);

    //     return () => {
    //         if (document.head.contains(styleElement)) {
    //             document.head.removeChild(styleElement);
    //         }
    //     };
    // }, []);

    useEffect(() => {
        const styleElement = document.createElement('style');
        styleElement.textContent = mobileStyles;
        document.head.appendChild(styleElement);

        // Run enforceLinkStyles after content is rendered
        enforceLinkStyles();
        // Run periodically to handle dynamic content
        const interval = setInterval(enforceLinkStyles, 1000);

        return () => {
            if (document.head.contains(styleElement)) {
                document.head.removeChild(styleElement);
            }
            clearInterval(interval);
        };
    }, [article]);

    const affiliationMap = new Map();
    article?.authors?.forEach((author) => {
        author?.author_anchor_affiliation?.forEach((affiliation) => {
            const key = `${affiliation?.department}|${affiliation?.university_name_1}|${affiliation?.country}`; // Remove uuid from the key to deduplicate
            if (!affiliationMap.has(key)) {
                affiliationMap.set(key, { number: affiliationMap.size + 1, affiliation });
            }
        });
    });

    // useEffect(() => {
    //     if (article?.authors?.length) {
    //         const missing = article.authors
    //             .filter(
    //                 (item) =>
    //                     item?.author_anchor_affiliation?.length === 0 &&
    //                     item?.is_anchor_id_required_at_affiliation === false||item?.is_anchor_id_required_at_affiliation===true
    //             )
    //             .map((item) => ({
    //                 department: item?.department || '',
    //                 university_name: item?.university_name_1 || '',
    //                 country: item?.country || '',
    //             }));

    //         setMissingAffiliations(missing);
    //     }
    // }, [article?.authors]);
    useEffect(() => {
        if (article?.authors?.length) {
            // Create a Set to store unique affiliation keys
            const uniqueAffiliations = new Set();

            const missing = article.authors
                .filter((item) => item?.author_anchor_affiliation?.length === 0) // Only include authors with no affiliations
                .map((item) => ({
                    department: item?.department || '',
                    university_name: item?.university_name_1 || '',
                    country: item?.country || '',
                }))
                .filter((affiliation) => {
                    // Create a unique key for deduplication
                    const key = `${affiliation.department}|${affiliation.university_name}|${affiliation.country}`;
                    if (uniqueAffiliations.has(key)) {
                        return false; // Skip duplicates
                    }
                    uniqueAffiliations.add(key);
                    return true; // Include unique entries
                });

            setMissingAffiliations(missing);
        }
    }, [article?.authors]);



    // let currentIndexx = 1;   

    return (
        <>
            <CourseHeader activeMenu={"CourseDetails"} />
            {/* <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <div className="breadcrumb-list">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Courses
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            All Courses
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            The Complete Web Developer Course 2.0
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <Bannerpage name={slug} />

            <div className="container-fluid p-5">
                <Row>
                    <StudentSideBar />
                    <Col lg={8} md={8} xs={12} style={{ backgroundColor: "#fff" }}>
                        <div className="cardb" style={{ paddingTop: 10 }}>
                            <Row>
                                <Col>
                                    {article?.volume_issue?.[0]?.issue_type === "special" ?
                                        <label>
                                            {article?.article_types?.[0]?.name} - {article?.volume_issue?.[0]?.issue_type}
                                        </label>
                                        :
                                        <label>
                                            {article?.article_types?.[0]?.name} - Volume {article?.volume_issue?.[0]?.volume} Issue {article?.volume_issue?.[0]?.issue}, {article?.year}
                                        </label>
                                    }
                                </Col>
                                <Col>
                                    <div style={{ textAlign: 'right' }}>
                                        <Link
                                            to={article?.pdf_url}
                                            target="_blank"
                                            onClick={e => {
                                                if (article?.article_access_types !== "open access") {
                                                    e.preventDefault();
                                                }
                                            }}
                                        >
                                            <button
                                                className="btn btn-primary"
                                                disabled={article?.article_access_types !== "open access"}
                                            >
                                                View PDF
                                            </button>
                                        </Link>
                                        &nbsp;
                                        {article?.article_access_types === "open access" ? (
                                            <PdfDownloader pdfUrl={article?.pdf_url} fileName="document.pdf">
                                                Download PDF
                                            </PdfDownloader>
                                        ) : (
                                            <button className="btn btn-secondary" disabled>
                                                Download PDF
                                            </button>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div style={{ marginTop: '8px' }}>
                            <strong style={{ fontSize: 25 }}>{article?.article_title}</strong>
                        </div>
                        {/* <div>
                            <Link
                                to={`/${slug}/author/${article?.slug}/archive`}
                                state={"article"}
                            // target="_blank"
                            >
                                <label>{article?.authors?.[0]?.author_name}</label>
                            </Link>
                        </div> */}
                        <div style={{ marginTop: '-3px' }}>
                            <label>
                                <Link
                                    to={`/${slug}/author/${article?.slug}/article`} s
                                    state={"article"}
                                    onClick={handleScrollToTop}
                                >
                                    {article?.authors?.map((item, indexData) => {
                                        const hasAffiliations = item?.author_anchor_affiliation?.length > 0;
                                        const isCorresponding = item?.author_type === "corresponding";
                                        return (
                                            <em key={indexData}>
                                                {item?.author_name}
                                                {hasAffiliations && item?.is_anchor_id_required_at_affiliation === true && (() => {
                                                    const supNumbers = new Set();

                                                    item?.author_anchor_affiliation?.forEach((affiliationItem) => {
                                                        const key = `${affiliationItem?.department}|${affiliationItem?.university_name_1}|${affiliationItem?.country}`;
                                                        const affiliationData = affiliationMap.get(key);
                                                        if (affiliationData) {
                                                            supNumbers.add(affiliationData.number);
                                                        }
                                                    });

                                                    const numbersArray = Array.from(supNumbers).sort((a, b) => a - b);
                                                    return numbersArray.length > 0 ? (
                                                        <sup>
                                                            <em>{numbersArray.join(",")}</em>
                                                        </sup>
                                                    ) : null;
                                                })()}
                                                {isCorresponding && <sup>*</sup>}
                                                {indexData < article?.authors?.length - 1 && ', '}
                                            </em>
                                        );
                                    })}
                                </Link>
                            </label>
                        </div>

                        {/* <div style={{ display: "flex" }}>
                            <strong>Corresponding Authors:</strong>
                            <label>
                                <Link
                                    to={`/${slug}/author/${article?.slug}/article`}
                                    state={"article"}
                                >
                                    {article?.authors
                                        ?.filter((item) => item?.author_type === "corresponding")
                                        ?.map((item, index, array) => (
                                            <em key={index}>
                                                {item?.author_name}
                                                {index < array.length - 1 && ', '}
                                            </em>
                                        ))}
                                </Link>
                            </label>
                        </div> */}
                        {article?.authors?.some((item) => item?.author_type === "corresponding") && (
                            <div style={{ display: "flex", marginTop: '8px' }}>
                                <strong>Corresponding Authors:</strong>
                                <label>
                                    <Link
                                        to={`/${slug}/author/${article?.slug}/article`}
                                        state={"article"}
                                    >
                                        {article?.authors
                                            ?.filter((item) => item?.author_type === "corresponding")
                                            ?.map((item, index, array) => {
                                                const hasAffiliations = item?.author_anchor_affiliation?.length > 0;
                                                return (
                                                    <em key={index}>
                                                        {item?.author_name}
                                                        {hasAffiliations && item?.is_anchor_id_required_at_affiliation === true && (() => {
                                                            const supNumbers = new Set();

                                                            item?.author_anchor_affiliation?.forEach((affiliationItem) => {
                                                                const key = `${affiliationItem?.department}|${affiliationItem?.university_name_1}|${affiliationItem?.country}`;
                                                                const affiliationData = affiliationMap.get(key);
                                                                if (affiliationData) {
                                                                    supNumbers.add(affiliationData.number);
                                                                }
                                                            });

                                                            const numbersArray = Array.from(supNumbers).sort((a, b) => a - b);
                                                            return numbersArray.length > 0 ? (
                                                                <sup style={{ marginLeft: '1px' }}>
                                                                    <em>{numbersArray.join(",")}</em>
                                                                </sup>
                                                            ) : null;
                                                        })()}
                                                        <sup style={{ marginLeft: '1px' }}>*</sup>,
                                                        {item?.email_1 && (
                                                            <span style={{ marginLeft: '2px' }}>
                                                                {item.email_1}
                                                                {item?.telephone &&
                                                                    /^\d{7,}$/.test(item.telephone) && ', '}
                                                            </span>
                                                        )}
                                                        {item?.telephone &&
                                                            /^\d{7,}$/.test(item.telephone) && ( // only digits, at least 7
                                                                <span style={{ marginLeft: '2px' }}>
                                                                    Tel: {item.telephone}
                                                                </span>
                                                            )}

                                                        {index < array.length - 1 && ', '}
                                                    </em>
                                                );
                                            })}
                                    </Link>
                                </label>
                            </div>
                        )}



                        {article?.authors?.length > 0 && (
                            <div
                                style={{ fontWeight: 'bold', cursor: 'pointer', marginTop: '8px', color: "#0066cc" }}
                                onClick={scrollToAuthorInfo}
                            >
                                Authors Info
                            </div>
                        )}

                        {/* Abstract Section */}
                        {article?.abstract && (
                            <div style={{ marginTop: '12px' }}>
                                <h3 style={{ lineHeight: '1.6', marginBottom: '8px', color: 'rgb(57,181,74)' }}>ABSTRACT</h3>
                                <div style={{ lineHeight: '1.9' }}>
                                    <ContentRenderer content={article?.abstract} />
                                </div>
                            </div>
                        )}
                        {article?.keyword && (
                            <div style={{ marginTop: '12px' }}>
                                <h3 style={{ lineHeight: '1.6', marginBottom: '8px', color: 'rgb(57,181,74)' }}>KEYWORDS</h3>
                                <div style={{ lineHeight: '1.9' }}>
                                    <ContentRenderer content={article?.keyword} />
                                </div>
                            </div>
                        )}





                        {/* {article?.fulltexts?.map((item, articleIndex) => {
                            return <div key={articleIndex}>
                                {item?.content &&
                                    <>
                                        <h3>{item?.heading_details?.[0]?.heading}</h3>
                                        <ContentRenderer content={item?.content} />
                                    </>
                                }
                            </div>
                        })} */}

                        {article?.fulltexts?.map((item, articleIndex) => {
                            console.log('Content before rendering:', item?.content);
                            return (
                                <div key={articleIndex} style={{ marginTop: '12px' }}>
                                    {item?.content && (
                                        <>
                                            {(() => {
                                                const { text, style } = getStyledHeading(item?.heading_details?.[0]?.heading);
                                                return (
                                                    <h3 style={{ lineHeight: '1.6', marginBottom: '8px', ...style }}>
                                                        {text}
                                                    </h3>
                                                )
                                            })()}
                                            <div style={{ lineHeight: '1.9' }}>
                                                <ContentRenderer content={item?.content} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            );
                        })}

                        {article?.authors?.length > 0 && (
                            <div id="info" style={{ marginTop: '16px' }}>
                                <div className="card"
                                    style={{
                                        borderColor: 'lightgray',
                                        backgroundColor: '#f8f9fa',
                                        padding: 16,
                                        borderRadius: 4
                                    }}>
                                    <strong style={{ fontSize: 20, marginBottom: '12px', display: 'block' }}>Author Info</strong>
                                    <div>

                                        {/* {article?.authors?.map((item, indexData) => {
                                            console.log(item, "ggg");

                                         
                                            const hasAffiliations = item?.author_anchor_affiliation?.length > 0;

                                            return (


                                                <label key={indexData}>
                                                    {item?.author_name}

                                                    {hasAffiliations && item?.is_anchor_id_required_at_affiliation === true && (() => {
                                                        let supNumbers = [];

                                                        item?.author_anchor_affiliation?.forEach((affiliationItem) => {
                                                            affiliationMap.forEach((number, key) => {
                                                                const [department, university, country, uuid] = key.split("|");
                                                                console.log(department, country, university, "dds");

                                                                if (affiliationItem?.uuid === uuid) {
                                                                    supNumbers.push(number); 
                                                                }
                                                            });
                                                        });

                                                        return supNumbers.length > 0 ? (
                                                            <sup>
                                                                <em>{supNumbers.join(",")}</em> 
                                                            </sup>
                                                        ) : null;
                                                    })()}

                                                    {indexData < article?.authors?.length - 1 && ',\u00A0'}

                                                </label>

                                            );
                                        })} */}

                                        {article?.authors?.map((item, indexData) => {
                                            const hasAffiliations = item?.author_anchor_affiliation?.length > 0;
                                            const isCorresponding = item?.author_type === "corresponding";
                                            console.log(item, 'vshsgxvsgchvs');
                                            return (
                                                <label key={indexData}>
                                                    {item?.author_name}

                                                    {hasAffiliations && item?.is_anchor_id_required_at_affiliation === true && (() => {
                                                        const supNumbers = new Set(); // Remove <number> type annotation


                                                        item?.author_anchor_affiliation?.forEach((affiliationItem) => {
                                                            const key = `${affiliationItem?.department}|${affiliationItem?.university_name_1}|${affiliationItem?.country}`;
                                                            const affiliationData = affiliationMap.get(key);
                                                            if (affiliationData) {
                                                                supNumbers.add(affiliationData.number);
                                                            }
                                                        });

                                                        const numbersArray = Array.from(supNumbers).sort((a, b) => a - b); // Sort numbers for consistency
                                                        return numbersArray.length > 0 ? (
                                                            <sup>
                                                                <em>{numbersArray.join(",")}</em>
                                                            </sup>
                                                        ) : null;
                                                    })()}
                                                    {isCorresponding && <sup>*</sup>}

                                                    {indexData < article?.authors?.length - 1 && ',\u00A0'}
                                                </label>
                                            );
                                        })}

                                    </div>
                                    {Array.from(affiliationMap.entries()).map(([key, data]) => {
                                        console.log(key, data, 'cvgdsvdchgsdvchsdbc');

                                        const { number, affiliation } = data;
                                        const { department, university_name_1: university, country } = affiliation;
                                        return (
                                            <label key={key}>

                                                <em><sup>{number}</sup></em>
                                                {department && ` ${department}`}
                                                {university && `, ${university}`}
                                                {country && `, ${country}`}

                                            </label>
                                        );
                                    })}
                                    {missingAffiliations?.length > 0 && missingAffiliations?.map((item, index) => {
                                        return (
                                            <label key={index}>
                                                {item?.department && `${item?.department}`}
                                                {item?.university_name && `, ${item?.university_name}`}
                                                {item?.country && `, ${item?.country}`}
                                            </label>
                                        )
                                    })}

                                    {/* {Array.from(affiliationMap.entries()).map(([key, number]) => {
                                        const [department, university, country] = key.split("|");
                                        return (
                                            <label key={number}>
                                                <em><sup>{number}</sup></em>Department of {department}
                                                {university && `, ${university}`}
                                                {country && `, ${country}`}
                                            </label>
                                        );
                                    })} */}

                                    {/*  */}
                                    {/* <label>Department of {article?.authors?.[0]?.department}, {article?.authors?.[0]?.institue_college}, {article?.authors?.[0]?.country}</label> */}
                                    {article?.article_citation &&
                                        <div style={{ marginTop: 12 }}>
                                            <b>Citation:</b> {article?.article_citation}
                                        </div>
                                    }
                                    <div style={{ marginTop: 12 }}>
                                        {article?.received_date && (
                                            <>
                                                <b>Received:</b> {moment(article.received_date).format('DD-MMM-YYYY')},{" "}
                                            </>
                                        )}
                                        {article?.manuscript_number && <> Manuscript No. {article.manuscript_number};&nbsp;</>}

                                        {article?.editor_assigned && (
                                            <>
                                                <b>Editor assigned:</b> {moment(article.editor_assigned).format('DD-MMM-YYYY')},{" "}
                                            </>
                                        )}
                                        {article?.pre_qc_number && <> Pre QC No. {article.pre_qc_number} (PQ);&nbsp;</>}

                                        {article?.reviewed_date && (
                                            <>
                                                <b>Reviewed:</b> {moment(article.reviewed_date).format('DD-MMM-YYYY')},{" "}
                                            </>
                                        )}
                                        {article?.qc_number && <> QC No. {article.qc_number};&nbsp;</>}

                                        {article?.revised_date && (
                                            <>
                                                <b>Revised:</b> {moment(article.revised_date).format('DD-MMM-YYYY')},{" "}
                                            </>
                                        )}
                                        {article?.manuscript_number && <> Manuscript No. {article.manuscript_number} (R);&nbsp;</>}

                                        {article?.published_date && (
                                            <>
                                                <b>Published:</b> {moment(article.published_date).format('DD-MMM-YYYY')}{" "}
                                            </>
                                        )}
                                        {article?.doi && <>, DOI: {article.doi}</>}
                                    </div>
                                    {article?.article_copyright &&
                                        <div style={{ marginTop: 12 }}>
                                            <b>Copyright:</b> {article?.article_copyright}

                                        </div>
                                    }
                                </div>
                            </div>
                        )
                        }

                    </Col>

                </Row>
            </div>
            <Footer />
        </>
    )
}

export default ArchiveHtml